import { useState, useEffect } from 'react';

export const useTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(() => {
    return navigator.maxTouchPoints > 0;
  });
  const checkTouchDevice = () => {
    setIsTouchDevice(navigator.maxTouchPoints > 0);
  };

  useEffect(() => {
    checkTouchDevice();
    window.addEventListener('resize', checkTouchDevice);

    return () => {
      window.removeEventListener('resize', checkTouchDevice);
    };
  }, []);

  return isTouchDevice;
};
